import { render } from "react-dom"
import React from "react"
import App from "./App"
import "./styles.css"

render(<App />, document.getElementById("root"))
